import React from 'react'

import {api} from '../services/api'
import {FaceOffRunListEntry} from '../services/coreApi/faceoff'
import {FetchStatus} from './useRecognitionAttempts'

export interface FaceOffRunsState {
  status: FetchStatus
  runs: FaceOffRunListEntry[]
  errorMessage: string | null
}

/** Loads the Face Off run list once on mount, newest first. */
export const useFaceOffRuns = (): FaceOffRunsState => {
  const [state, setState] = React.useState<FaceOffRunsState>({
    status: 'pending',
    runs: [],
    errorMessage: null,
  })

  React.useEffect(() => {
    let cancelled = false

    api.faceoff.getFaceOffRuns().then((response) => {
      if (cancelled) return
      if (response.result === 'success') {
        setState({status: 'resolved', runs: response.data, errorMessage: null})
      } else {
        setState({
          status: 'rejected',
          runs: [],
          errorMessage: response.error.message,
        })
      }
    })

    return (): void => {
      cancelled = true
    }
  }, [])

  return state
}
